var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"caps-lock-is-active-message flex gap-2 text-warning items-center"},[_c('a-icon',{attrs:{"type":"info-circle"}}),_vm._v(" "+_vm._s(_vm.$t('caps_lock_is_on_message'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }